import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CtaButtonProps {
  label: string;
  sub?: string;
  size?: 'lg' | 'md';
  variant?: 'primary' | 'light';
  id?: string;
  className?: string;
}
export function CtaButton({
  label,
  sub,
  size = 'lg',
  variant = 'primary',
  id,
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-xl text-center font-display font-extrabold uppercase leading-tight tracking-tight transition-[transform,background-color,box-shadow] duration-150 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2';
  const sizes = size === 'lg' ? 'px-5 py-4 text-[15px] sm:text-lg' : 'px-4 py-3.5 text-[13.5px] sm:text-base';
  const variants = variant === 'primary' ? 'bg-brand-500 text-white shadow-cta hover:bg-brand-600 focus-visible:outline-brand-300' : 'bg-white text-navy-900 shadow-card hover:bg-brand-50 focus-visible:outline-white';
  return <div className={`w-full ${className}`} data-id="element-28" data-mp="39y7w9wth944z">
      <a id={id} href={CHECKOUT_URL} className={`${base} ${sizes} ${variants}`} data-id="element-29" data-mp="39z9i8wc17b1h">
        <span className="max-w-[22ch] sm:max-w-none" data-id="element-30" data-mp="3ezx9nj469tw8">{label}</span>
        <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-31" data-mp="3jxqf29xnijvg" />
      </a>
      {sub ? <p className={`mt-2.5 text-center text-[12px] font-medium ${variant === 'primary' ? 'text-ink-500' : 'text-brand-100'}`} data-id="element-32" data-mp="3swkahwz8x47f">
          {sub}
        </p> : null}
    </div>;
}